import axios from '@/utils/axios';
interface ResponseCenterBranch extends api.commonResponse {
  branches: {
    _id: string;
    name: string;
  };
}

/*
  지점 API set 입니다.
*/
export function useCenter() {
  const getCenters = async (payload: { name?: string; branchId?: string; page: number; perPage: number }) => {
    try {
      const { data } = await axios.get<api.center.dropdownList.response>(
        `centers/list?page=${payload.page}&perPage=${payload.perPage}&name=${payload.name}&branchId=${payload.branchId}`,
        { headers: { 'X-bypass': true } }
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  /**
   * 유닛초대로 계정등록화면 넘어온 유저의 지점 검색
   */
  const getCentersInvitations = async (payload: { name?: string; token: string; page: number; perPage: number }) => {
    try {
      const param = payload.token;
      const { data } = await axios.get<api.center.dropdownList.response>(
        `centers/units/invitations/${payload.token}?page=${payload.page}&perPage=${payload.perPage}&name=${payload.name}`
      );
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  const getDropDownCenterList = async () => {
    try {
      const { data } = await axios.get<api.center.dropdownList.response>('centers/list?page=1&perPage=999', {
        headers: { 'X-bypass': true },
      });
      if (!data.success) throw data;
      return data;
    } catch (e) {
      throw e;
    }
  };

  const getCenterState = async () => {
    try {
      const { data } = await axios.get<api.center.serviceState.response>('centers/service/state');

      return data.service;
    } catch (error) {
      throw error;
    }
  };

  const patchUserCenter = async (payload: api.center.patchCenter.payload) => {
    try {
      const { data } = await axios.patch<api.center.patchCenter.response>('centers', payload);

      return data;
    } catch (error) {
      throw error;
    }
  };

  const getCenterNotice = async () => {
    try {
      const { data } = await axios.get<api.center.notice.response>(`centers/notice`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  //지점별 택배 규격 조회
  const getCenterParcelCategory = async (payload: api.center.parcelSize.payload): Promise<any> => {
    try {
      const { data } = await axios.get<api.center.parcelSize.response>(`centers/parcel-category/${payload.centerId}`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  /** 지점별 택배 물품가액 조회 */
  const getCenterParcelItemPriceList = async (payload: api.center.parcelItemPricePayload): Promise<any> => {
    try {
      const { data } = await axios.get<api.center.parcelItemPriceResponse>(
        `centers/${payload.centerId}/parcel-item-prices`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  /**
   * 지점 + 카테고리별 커스텀필드 정보 조회
   * @param payload centerId , category(서비스 종류)
   * @returns
   */
  const getCenterCustomFields = async (payload: api.center.customFields.payload) => {
    try {
      const { data } = await axios.get<api.center.customFields.response>(
        `centers/${payload.centerId}/custom-fields?category=${payload.category}`
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  /**
   * 지점별 급송 사용여부 조회
   * @param payload centerId
   * @returns { isExpressQuickAvailable :boolean }
   */
  const getCenterExpressAvailable = async (payload: api.center.isUseExpressPayload): Promise<any> => {
    try {
      const { data } = await axios.get<api.center.isUseExpressResponse>(
        `centers/${payload.centerId}/express-quick/available`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  /**
   * 지점 방문결제가 금지된 지점 목록 조회
   * @returns
   */
  const getNotAllowedCatPayment = async () => {
    try {
      const { data } = await axios.get(`centers/not-allowed-in-person-payment`);

      return data;
    } catch (error) {
      throw error;
    }
  };

  /**
   * 지점별 구내픽업 서비스 운영시간(요일별) 조회
   * @returns
   */
  const getCenterPickupServiceOptions = async () => {
    try {
      const { data } = await axios.get('/centers/onsite-pickup-options');
      return data;
    } catch (error) {
      throw error;
    }
  };
  /**
   * 지점별 구내픽업 서비스 운영시간(요일별) 조회
   * @returns
   */
  const getCenterPickupServiceTimes = async () => {
    try {
      const { data } = await axios.get('/centers/onsite-pickup-operation-times');
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    getCenters,
    getCentersInvitations,
    getDropDownCenterList,
    getCenterState,
    patchUserCenter,
    getCenterNotice,
    getCenterParcelCategory,
    getCenterParcelItemPriceList,
    getCenterCustomFields,
    getNotAllowedCatPayment,
    getCenterExpressAvailable,
    getCenterPickupServiceOptions,
    getCenterPickupServiceTimes,
  };
}
